interface Activation {
    date: {
        end: string | null;
        start: string | null;
    };
    display: "enable" | "disable" | "scheduled";
}

const checkActivation = (activation: Activation) => {
    if (!activation) {
        return false;
    }

    if (activation.display === "enable") {
        return true;
    }

    if (activation.display === "scheduled" && !!activation.date.start && !!activation.date.end) {
        const start = new Date(activation.date.start).getTime();
        const end = new Date(activation.date.end).getTime();

        if (isNaN(start) || isNaN(end)) {
            return false;
        }

        const now = Date.now();

        return now > start && now < end;
    }

    return false;
};

export default checkActivation;
